module.exports = __webpack_public_path__ + "img/nav-right-search-below-ford.ff3c90f4.png";